var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"courses"},[_c('HeadersComponent'),_c('CoursesTagsComponent'),_c('CoursesTryFreeComponent'),_c('CoursesCardsComponent'),_c('MainFormConsultation',{attrs:{"title":"Не можете определиться с выбором?"}}),_c('CoursesCorporateComponent'),_c('FooterComponent')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }